import { render, staticRenderFns } from "./bodyprint-skeleton-line.vue?vue&type=template&id=a9e2ea98"
import script from "./bodyprint-skeleton-line.vue?vue&type=script&lang=js"
export * from "./bodyprint-skeleton-line.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports